import { render, staticRenderFns } from "./ScreeningFormChooseContact.vue?vue&type=template&id=ddc1dc60&scoped=true&"
import script from "./ScreeningFormChooseContact.vue?vue&type=script&lang=js&"
export * from "./ScreeningFormChooseContact.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningFormChooseContact.vue?vue&type=style&index=0&id=ddc1dc60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc1dc60",
  null
  
)

export default component.exports